<template>
	<div class="toasts">
		<transition-group name="toast-slide">
			<toast v-for="m in messages" :key="m.id" v-bind="m" @click.native="close(m)" />
		</transition-group>
	</div>
</template>

<script>
import Toast from '@/components/Toast'

export default {
	name: 'Toasts',
	computed: {
		messages() {
			return this.$store.state.toast.messages
		},
	},
	methods: {
		close({ id }) {
			this.$store.dispatch('toast/pop', id)
		},
	},
	components: {
		Toast,
	},
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/mq';

.toasts {
	position: fixed;
	top: 0;
	right: 0;
	z-index: 1000;

	@include mq(md) {
		top: initial;
		bottom: 0;
	}
}

.toast-slide {
	$spd: 0.4s;

	&-enter,
	&-leave-to {
		transform: translateX(4rem);
		opacity: 0;
	}
	&-enter-active {
		transition: transform $spd $ease-out-sine, opacity $spd $ease-out-sine;
	}
	&-leave-active {
		transition: transform $spd $ease-in-sine, opacity $spd $ease-in-sine;
	}
}
</style>
